import { Button } from "@nxtvid/component-library"
import './checkoutSuccess.css';

const CheckOutSuccess = () =>{
    return(
        <div className="checkout-success-message">
            <h2>Payment Successful</h2>
            <p>Your payment was successful! All funds will be held in escrow and will not be released to the videographer until you mark the project as completed.</p>
            <Button size='medium' type='primary' label='Go Back to Inbox' onClick={()=>window.location.href = '/Inbox'}/>
        </div>
    )
}

export default CheckOutSuccess;